"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerformanceBandService = void 0;
var performance_band_1 = require("../constants/performance-band");
/**
 * Service to retrieve the performance bands.
 *
 * At this point it return mocked data for any curriculum.
 */
var PerformanceBandService = /** @class */ (function () {
    function PerformanceBandService() {
    }
    /**
     * It returns the performance band associated with the curriculum
     * @param curriculum
     */
    PerformanceBandService.prototype.findByCurriculum = function (curriculum) {
        return performance_band_1.DefaultPerformanceBands;
    };
    return PerformanceBandService;
}());
exports.PerformanceBandService = PerformanceBandService;
